import { FC, useCallback, useState } from 'react';

import { ExclamationIcon } from '@heroicons/react/outline';

import { SHARE_GUIDE_DISMISSED_KEY } from '../utils/giftOrderCoupon.utils';

interface ShareGuideModalProps {
  open: boolean;
  onConfirm: () => void;
  onClose: () => void;
}

export const ShareGuideModal: FC<ShareGuideModalProps> = ({
  open,
  onConfirm,
  onClose,
}) => {
  const [dontShowAgain, setDontShowAgain] = useState(false);

  const handleConfirm = useCallback(() => {
    if (dontShowAgain) {
      localStorage.setItem(SHARE_GUIDE_DISMISSED_KEY, 'true');
    }
    onConfirm();
  }, [dontShowAgain, onConfirm]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 px-6">
      <div className="w-full max-w-sm rounded-2xl bg-white p-6 shadow-xl">
        <div className="mb-4 flex items-center gap-3">
          <div className="flex h-10 w-10 items-center justify-center rounded-full bg-amber-100">
            <ExclamationIcon className="h-6 w-6 text-amber-600" />
          </div>
          <h3 className="text-lg font-bold text-gray-800">안내</h3>
        </div>

        <p className="mb-3 break-keep text-sm leading-relaxed text-gray-700">
          한 번에 여러 명에게 공유하시면{' '}
          <span className="font-bold text-red-500">
            같은 코드가 중복 발송되어 문제가 발생
          </span>
          할 수 있습니다.
        </p>
        <p className="mb-3 break-keep text-sm leading-relaxed text-gray-700">
          전달 시에는 꼭{' '}
          <span className="font-bold text-purple-600">한 번에 한 명씩</span> 전달해
          주세요.
        </p>

        <label className="mb-5 flex cursor-pointer items-center gap-2">
          <input
            type="checkbox"
            checked={dontShowAgain}
            onChange={(e) => setDontShowAgain(e.target.checked)}
            className="h-4 w-4 rounded border-gray-300 text-purple-600 focus:ring-purple-500"
          />
          <span className="text-sm text-gray-500">다시 보지 않기</span>
        </label>

        <div className="flex gap-2">
          <button
            onClick={onClose}
            className="flex-1 rounded-xl border border-gray-300 py-3 text-sm font-medium text-gray-600 active:bg-gray-50"
          >
            취소
          </button>
          <button
            onClick={handleConfirm}
            className="flex-1 rounded-xl bg-purple-600 py-3 text-sm font-bold text-white active:bg-purple-700"
          >
            확인
          </button>
        </div>
      </div>
    </div>
  );
};
